import kaplay from "kaplay";
import load_sprites from "./load_sprite";
import { make_button, make_home_page } from "./ui";
import { make_outdoors } from "./outdoors";
import add_level from "./grid";
import { levels } from "./levels";

const k = kaplay({
  scale: 2,
  width: 480,
  height: 270,
  stretch: true,
  letterbox: true,
});

k.loadRoot("./"); // A good idea for Itch.io publishing later
k.setLayers(["bg", "under", "furniture", "above", "top", "ui"], "bg");

load_sprites(k);

const levels_done = [false, false, false, false, false, false, false, false, false, false, false, false, false, false];

let music: any = undefined;

k.scene("game", (id) => {
  k.setBackground(k.rgb(0, 0, 0));
  make_button(k, () => k.go("home"), 20, 20, 5, 5, "<-", { outline: 1 });
  add_level(k, levels[id], id, levels_done);
})
k.scene("home", () => {
  k.onClick(() => {
    k.loadMusic("music", "audio/music.ogg");
    k.loadSound("chomp", "audio/chomp.ogg");
    k.loadSound("slurp", "audio/slurp.ogg");
    k.loadSound("can", "audio/can.ogg");
    k.loadSound("meow_win", "audio/meow_win.ogg");
    k.loadSound("eat_pumpkin", "audio/eat_pumpkin.ogg");
    k.loadSound("grumpy_meow", "audio/grumpy_meow.ogg");
    if (!music) music = k.play("music", { loop: true });
  });
  make_outdoors(k);
  make_home_page(k, levels_done);
});
k.go("home");
